var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFranckJulien(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91458 22.9168C9.40422 21.2524 8.63427 20.0117 7.60474 19.1945C6.06041 17.9687 3.60668 18.7305 2.7003 17.4662C1.79392 16.2018 3.33532 13.8767 3.87622 12.5048C4.41711 11.1329 1.80301 10.6478 2.1082 10.2583C2.31167 9.99868 3.63266 9.24941 6.07119 8.01056C6.76406 4.05918 9.32333 2.0835 13.7491 2.0835C20.3875 2.0835 22.9167 7.7116 22.9167 11.2912C22.9167 14.8709 19.8542 18.7273 15.4917 19.5588C15.1016 20.127 15.6643 21.2463 17.1796 22.9168",
    stroke: "#989184",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1561 7.55227C9.81583 8.87222 9.91708 9.79904 10.4598 10.3327C11.0026 10.8665 11.9277 11.2155 13.235 11.3798C12.9384 13.0823 13.3 13.881 14.3199 13.7759C15.3398 13.6708 15.9525 13.247 16.1583 12.5045C17.7522 12.9525 18.616 12.5776 18.7498 11.3798C18.9506 9.58316 17.9818 8.14993 17.5846 8.14993C17.1873 8.14993 16.1583 8.1016 16.1583 7.55227C16.1583 7.0029 14.9562 6.69253 13.8713 6.69253C12.7864 6.69253 13.4393 5.96123 11.9496 6.25019C10.9564 6.44279 10.3586 6.8768 10.1561 7.55227Z",
    stroke: "#989184",
    strokeWidth: 1.625,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8855 13.2812C15.3559 13.6099 14.6291 14.1564 14.323 14.5833C13.558 15.6508 12.9374 16.3007 12.8016 16.9834",
    stroke: "#989184",
    strokeWidth: 1.625,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFranckJulien);
export default __webpack_public_path__ + "static/media/icon-franck-julien.faf78885a9ff1a2a5391811a6c1fd310.svg";
export { ForwardRef as ReactComponent };